import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSavingPiggyBank = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "saving-piggy-bank" }),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M23.25,9.5a3,3,0,0,1-3,3"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M8.25,8a6.763,6.763,0,0,1,6,0"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M6.375,11a.375.375,0,1,0,.375.375A.375.375,0,0,0,6.375,11"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M7.9,4.883C6.726,2.756,3.75,2.75,3.75,2.75l.626,4.384A8.058,8.058,0,0,0,2.6,10.25H.75v6H3.24a8.467,8.467,0,0,0,2.01,2.372V21.5a.75.75,0,0,0,.75.75H7.5a.75.75,0,0,0,.75-.75V20.259a9.512,9.512,0,0,0,6,.011V21.5a.75.75,0,0,0,.75.75h1.5a.75.75,0,0,0,.75-.75V18.637a7.941,7.941,0,0,0,3-6.137C20.25,6.006,13.2,3.111,7.9,4.883Z"
		})
	]
});
export default SvgSavingPiggyBank;
